module.exports = __webpack_public_path__ + "static/saygrace-c8f85741ad51f521cc31b195af8ce32c.webm";